import { Modal, Box, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import React from "react";

const UrlCopiedModal = ({ open, onClose }) => {
  return (
    <Modal
      keepMounted
      open={open}
      onClose={onClose}
      aria-labelledby="keep-mounted-modal-title"
      aria-describedby="keep-mounted-modal-description"
    >
      <Box
        sx={{
          position: "relative",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: {
            xs: "75%",
            sm: "280px",
            md: "320px",
          },
          bgcolor: "#2e2e2e",
          border: "5px solid #faa61a",
          borderRadius: "10px",
          outline: "none",
          p: 3,
          maxHeight: "80vh",
        }}
      >
        <IconButton
          sx={{
            position: "absolute",
            top: "-20px",
            right: "-20px",
            bgcolor: "#faa61a",
            color: "#000",
            "&:hover": {
              bgcolor: "#faa61a",
            },
          }}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Typography variant="h5" style={{ color: "#faa61a" }}>
            URL copied to clipboard
          </Typography>
        </Box>
      </Box>
    </Modal>
  );
};

export default UrlCopiedModal;
